export { default as rActivateAccount } from './activateAccount';
export { default as rLogOut } from './logOut';
export { default as rLogin } from './login';
export { default as rNewPassword } from './newPassword';
export { default as rRegister } from './register';
export { default as rResetPassword } from './resetPassword';
export { default as rUnblockUser } from './unblockUser';
